const FORM_BTN_VAR_STRIP_RE = /--form-btn-(?:hover-color|bg-hover|bg|color)\s*:\s*[^;]+;?\s*/gi;

export default function mergeFormInputsCtaStyle(el, ctaStyle) {
	if (!el || !ctaStyle || typeof ctaStyle !== 'string') {
		return;
	}
	const existing = (el.getAttribute('style') || '').replace(FORM_BTN_VAR_STRIP_RE, '').trim().replace(/;\s*$/, '');
	const merged = existing ? `${existing}; ${ctaStyle}` : ctaStyle;
	el.setAttribute('style', merged);
}
